// 公司介绍
<template>
  <div class="main">
    <myheadert></myheadert>
    <div class="head">
      <!-- <img src="~@/assets/aboutMe_img/gratisography.jpg"> -->
      <img src="~@/assets/aboutMe_img/u6086-4.png" class="title" />
    </div>
    <div class="middle">
      <div class="location">
        <img src="~@/assets/common_img/house.png" />
        <span class="place">您的位置：&nbsp;<span @click="goHome">主页</span>＞关于我们＞企业简介</span>
      </div>
      <div class="lead">
        <ul>
          <li class="lead_first"><a href="#/introduce">企业简介</a></li>
          <li><a href="#/experience">成长历程</a></li>
          <li><a href="#/business">企业资质</a></li>
          <li><a href="#/address">企业地图</a></li>
          <li><a href="#/contact">联系我们</a></li>
        </ul>
      </div>
      <div class="line"></div>
    </div>
    <div class="introduce">
      <div class="Ctitle">北京惠泽智业科技有限公司简介</div>
      <div class="content">
        <p class="MsoNormal" >
          <span>公司成立于</span
          ><span style="font-size: 9pt"
            ><span lang="EN-US">2017</span
            ><span>年</span><span lang="EN-US">1</span
            ><span>月，注册资金</span
            ><span lang="EN-US">1050</span>
            <span>万，创始人团队有</span
            ><span lang="EN-US">20</span
            ><span>多年的软件研发经验和</span
            ><span lang="EN-US">16</span></span
          ><span
            >年的工程管理经验，覆盖弱电工程、通信工程、低压电力工程、信息化项目、系统集成项目等等。</span
          >
        </p>
        <p class="MsoNormal" >
          <span>
            一、营业执照注册上的经营范围：技术开发、技术转让、技术咨询、技术培训、技术服务；电子产品、家居装饰、集成电路、电子工程的设计；工程设计；建筑智能化系统专项设计；计算机系统集成；信息系统集成服务；数据处理（数据处理中的银行卡中心、</span
          ><span style="font-size: 9pt"
            ><span lang="EN-US">PUE</span
            ><span>值在</span
            ><span lang="EN-US">1</span>
            <span>；</span
            ><span lang="EN-US">5</span></span
          ><span
            >以上的云计算数据中心除外）；设备安装、维修；专业承包、劳务分包、施工总承包；销售计算机、软件及辅助设备、通讯设备、建筑材料、自动控制设备、机电设备、消防设备、仪器仪表；家居装饰。（以工商行政管理机关核定的经营范围为准。）</span
          >
        </p>
        <p class="MsoNormal" >
          <span
            >二、公司主营业务介绍：</span
          >
        </p>
        <p class="MsoNormal" >
          <span style="font-size: 9pt" lang="EN-US">1.LED</span>
          <span style="font-size: 9pt">
            <span>显示屏工程，与利亚德公司有非常深入的合作，可以承接各种室内、室外</span>
            <span lang="EN-US">LED</span>
            </span>
            <span>显示屏工程。</span>
        </p>
        <p class="MsoNormal" >
          <span style="font-size: 9pt" lang="EN-US">2.</span
          ><span
            >广播工程，公司可以设计、实施各种公共广播工程、背景音乐工程等等，技术团队可以为客户定制广播控制系统，实现特殊的广播需求。</span
          >
        </p>
        <p class="MsoNormal" >
          <span style="font-size: 9pt" lang="EN-US">3.</span
          ><span
            >视频会议系统，可以设计、实施硬件视频会议系统和软件视频会议系统，包括主机房、主会场、分会场的设计与施工等等。</span
          >
        </p>
        <p class="MsoNormal" >
          <span style="font-size: 9pt" lang="EN-US">4.</span
          ><span
            >会议系统，可以设计、实施会议室的扩音系统、录音录像系统、投影显示系统等等。</span
          >
        </p>
        <p class="MsoNormal" >
          <span style="font-size: 9pt" lang="EN-US">5.</span
          ><span
            >监控工程，可以实施各种监控系统工程。</span
          >
        </p>
        <p class="MsoNormal" >
          <span style="font-size: 9pt" lang="EN-US">6.</span
          ><span style="font-size: 9pt"
            ><span
              >绿色照明系统控制工程，公司创始人在</span
            ><span lang="EN-US">2001</span></span
          ><span
            >年为包头火车站建设绿色照明系统控制工程，两年内节约的电费就收回了全部投资。</span
          >
        </p>
        <p class="MsoNormal" >
          <span style="font-size: 9pt" lang="EN-US">7.</span
          ><span
            >路灯照明工程，建筑物亮化工程等。</span
          >
        </p>
        <p class="MsoNormal" >
          <span style="font-size: 9pt" lang="EN-US">8.</span
          ><span
            >综合布线工程，机房工程，可以承接机房防静电地板、机房内网络设备、服务器、空调、门禁系统的安装调试，等等。</span
          >
        </p>
        <p class="MsoNormal" >
          <span style="font-size: 9pt" lang="EN-US">9.</span
          ><span
            >通信工程，可以布放光缆、电缆，建设机房等等。</span
          >
        </p>
        <p class="MsoNormal" >
          <span style="font-size: 9pt" lang="EN-US">10.</span
          ><span
            >软件开发，能够根据客户的业务需求，定制开发各种管理软件。</span
          >
        </p>
        <p class="MsoNormal" >
          <span style="font-size: 9pt" lang="EN-US">11.</span
          ><span
            >多媒体教室、多媒体教学系统，可以建设本地教学系统、远程教学系统等等。</span
          >
        </p>
        <p class="MsoNormal" >
          <span style="font-size: 9pt" lang="EN-US">12.</span
          ><span style="font-size: 9pt"
            ><span
              >公司的核心业务是智能硬件产品与配套系统的研发，目前已经申请到三项专利，正在研究产品的实现。</span
            > </span
          ><span>
            如果有特殊的功能需求，公司可以定制研究、开发、生产满足特殊功能的产品。</span
          >
        </p>
        <p class="MsoNormal" >
          <span
          >三、家庭教育</span
          >
        </p>
        <p class="MsoNormal" >
          <span style="font-size: 9pt">针对中小学生面对的升学压力，公司引进国内外先进教育理念和教学方法，开发高效的语数外等各科助学软件，助力莘莘学子，升学路上先人一步。</span>
        </p>
        <p class="MsoNormal" >
          <span
          >四、外语学习软件</span
          >
        </p>
        <p class="MsoNormal" >
          <span style="font-size: 9pt">公司致力于为全球语言学习者开发独一无二的、简便高效的、百分之百符合人类语言自然习得原理的各门类、各语种外语学习软件。</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'introduce',
  methods: {
    goHome () {
      this.$router.push(
        {
          path: '/'
        }
      )
      location.reload()
    }
  }
}
</script>
<style scoped>
* {
  margin: 0;
}
@media screen and (min-width: 1500px) {
  /* 顶部 */
  .head {
    width: 100%;
    height: 253px;
    background-image: url("~@/assets/aboutMe_img/gratisography.jpg");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title {
    width: 900px;
    margin-top: 25px;
  }
  /* 位置 */
  .location {
    width: auto;
    height: 27px;
    /* border: 1px red solid; */
    margin-top: 1%;
    margin-left: 14.5%;
    font-size: 18px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img {
    display: inline-block;
  }
  .place {
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /* 关于我们-导航 */
  .lead {
    margin-left: 61%;
    margin-bottom: 0;
  }
  .lead ul {
    list-style: none;
  }
  .lead ul li {
    width: 12%;
    height: 27px;
    float: left;
    text-align: center;
    line-height: 27px;
  }
  .lead a {
    text-decoration: none;
    color: black;
    font-family: "黑体";
    font-size: 15px;
  }
  .lead_first {
    background-color: #f15a24;
  }
  /* 线 */
  .line {
    width: 100%;
    height: 1px;
    background-color: black;
    margin-top: 26px;
  }
  /* 公司介绍 */
  .Ctitle {
    text-align: center;
    font-size: 25px;
    position: relative;
    top: 10px;
  }
  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 11pt;
    font-family: '宋体'
  }
}
@media screen and (min-width: 1200px) and (max-width: 1499px) {
  /* 顶部 */
  .head {
    width: 100%;
    height: 253px;
    background-image: url("~@/assets/aboutMe_img/gratisography.jpg");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title {
    width: 750px;
    margin-top: 20px;
  }
  /* 位置 */
  .location {
    width: auto;
    height: 27px;
    /* border: 1px red solid; */
    margin-top: -3%;
    margin-left: 14.5%;
    font-size: 18px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img {
    display: inline-block;
  }
  .place {
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /* 关于我们-导航 */
  .lead {
    margin-left: 61%;
    margin-bottom: 0;
  }
  .lead ul {
    list-style: none;
  }
  .lead ul li {
    width: 15%;
    height: 27px;
    float: left;
    text-align: center;
    line-height: 27px;
  }
  .lead a {
    text-decoration: none;
    color: black;
    font-family: "黑体";
    font-size: 15px;
  }
  .lead_first {
    background-color: #f15a24;
  }
  /* 线 */
  .line {
    width: 100%;
    height: 1px;
    background-color: black;
    margin-top: 26px;
  }
  /* 公司介绍 */
  .Ctitle {
    text-align: center;
    font-size: 25px;
    position: relative;
    top: 10px;
  }
  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }
}
@media screen and (min-width: 960px) and (max-width: 1199px) {
  /* 顶部 */
  .head {
    width: 100%;
    height: 253px;
    background-image: url("~@/assets/aboutMe_img/gratisography.jpg");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title {
    width: 600px;
    /* margin-left: 20px; */
    margin-top: 10px;
  }
  /* 位置 */
  .location {
    width: auto;
    height: 20px;
    /* border: 1px red solid; */
    margin-top: -6%;
    margin-left: 14.5%;
    font-size: 16px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img {
    width: 3%;
    display: inline-block;
  }
  .place {
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /* 关于我们-导航 */
  .lead {
    margin-left: 61%;
    margin-bottom: 0;
  }
  .lead ul {
    list-style: none;
  }
  .lead ul li {
    width: 20%;
    height: 27px;
    float: left;
    text-align: center;
    line-height: 27px;
  }
  .lead a {
    text-decoration: none;
    color: black;
    font-family: "黑体";
    font-size: 15px;
  }
  .lead_first {
    background-color: #f15a24;
  }
  /* 线 */
  .line {
    width: 100%;
    height: 1px;
    background-color: black;
    margin-top: 26px;
  }
  /* 公司介绍 */
  .Ctitle {
    text-align: center;
    font-size: 25px;
    position: relative;
    top: 10px;
  }
  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }
}
@media screen and (min-width: 768px) and (max-width: 959px) {
  /* 顶部 */
  .head {
    width: 100%;
    height: 253px;
    background-image: url("~@/assets/aboutMe_img/gratisography.jpg");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title {
    width: 400px;
    /* margin-left: 30px; */
    /* margin-top: 10px; */
  }
  /* 位置 */
  .location {
    width: auto;
    height: 20px;
    /* border: 1px red solid; */
    margin-top: -11%;
    margin-left: 14.5%;
    font-size: 12px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img {
    width: 3%;
    display: inline-block;
  }
  .place {
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /* 关于我们-导航 */
  .lead {
    margin-left: 61%;
    margin-bottom: 0;
  }
  .lead ul {
    list-style: none;
  }
  .lead ul li {
    width: 20%;
    height: 20px;
    float: left;
    text-align: center;
    line-height: 20px;
  }
  .lead a {
    text-decoration: none;
    color: black;
    font-family: "黑体";
    font-size: 12px;
  }
  .lead_first {
    background-color: #f15a24;
  }
  /* 线 */
  .line {
    width: 100%;
    height: 1px;
    background-color: black;
    margin-top: 20px;
  }
  /* 公司介绍 */
  .Ctitle {
    text-align: center;
    font-size: 25px;
    position: relative;
    top: 10px;
  }
  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }
}
@media screen and (min-width: 702px) and (max-width: 767px) {
  /* 顶部 */
  .head {
    width: 100%;
    height: 253px;
    background-image: url("~@/assets/aboutMe_img/gratisography.jpg");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title {
    width: 500px;
    margin-left: 50px;
  }
  /* 位置 */
  .location {
    width: auto;
    height: 27px;
    /* border: 1px red solid; */
    margin-top: -12%;
    margin-left: 14.5%;
    font-size: 12px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img {
    width: 3%;
    display: inline-block;
  }
  .place {
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /* 关于我们-导航 */
  .lead {
    margin-left: 61%;
    margin-bottom: 0;
  }
  .lead ul {
    list-style: none;
  }
  .lead ul li {
    width: 20%;
    height: 20px;
    float: left;
    text-align: center;
    line-height: 20px;
  }
  .lead a {
    text-decoration: none;
    color: black;
    font-family: "黑体";
    font-size: 12px;
  }
  .lead_first {
    background-color: #f15a24;
  }
  /* 线 */
  .line {
    width: 100%;
    height: 1px;
    background-color: black;
    margin-top: 20px;
  }
  /* 公司介绍 */
  .Ctitle {
    text-align: center;
    font-size: 25px;
    position: relative;
    top: 10px;
  }
  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }
}
@media screen and (max-width: 701px) {
  .main {
    width: 100%;
    height: auto;
  }
  /* 顶部 */
  .head {
    width: 100%;
    height: auto;
    background-image: url("~@/assets/aboutMe_img/gratisography.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .title {
    width: 50%;
    margin-left: 30%;
    margin-top: 10px;
  }
  /* 位置 */
  .location {
    width: auto;
    height: 20px;
    margin-top: 10px;
    margin-left: 10%;
    font-size: 12px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img {
    width: 6%;
    display: inline-block;
  }
  .place {
    position: relative;
    left: 1.2%;
    top: -5px;
    cursor: pointer;
  }
  /* 关于我们-导航 */
  /* .lead{
  margin-left: 61%;
  margin-bottom: 0;
} */
  .lead ul {
    list-style: none;
    margin-top: 20px;
    /* margin-left: 10%; */
  }
  .lead ul li {
    width: 20%;
    height: 14px;
    float: left;
    text-align: center;
    line-height: 12px;
    /* margin-left: 10px; */
  }
  .lead a {
    text-decoration: none;
    color: black;
    font-family: "黑体";
    font-size: 12px;
  }
  .lead_first {
    background-color: #f15a24;
  }
  /* 线 */
  .line {
    width: 100%;
    height: 1px;
    background-color: black;
    margin-top: 34px;
  }
  /* 公司介绍 */
  .Ctitle {
    text-align: center;
    font-size: 16px;
    position: relative;
    top: 10px;
  }
  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aboutMe/introduce.vue